export default __webpack_public_path__ + "static/media/matching-team-1.f9b684f5.png";